import React, { useEffect } from 'react';

// custom components
import { StatCards } from '_atoms';

//date
import moment from 'moment';

// redux
import { useSelector } from 'react-redux';
import { selectPassengerBreakdownSummary, selectSelectedReportType, selectPassengerRecordsReportSummary} from 'redux/slices/timeline-reports/timeline-reports';
import { selectReportSummary, selectCustomReportData } from '_redux/slices/timeline-report-builder/timeline-report-builder';

// range dates are plain YYYY-MM-DD; new Date() reads them as UTC midnight, which shows
// the day before west of UTC (PUJ saw 17 Sep - 1 Oct as 16/09 - 30/09). moment reads them as local.
const formatRangeDate = (date) => moment(date).toDate().toLocaleDateString();

const PassengerStatCards = (props) => {

  // redux
  const summary = useSelector(selectPassengerBreakdownSummary);
  const passengerRecordsSummary = useSelector(selectPassengerRecordsReportSummary);
  const selectedReportType = useSelector(selectSelectedReportType) || 'passenger-records';

  // custom builder
  const builderSummary = useSelector(selectReportSummary)
  const customReport = useSelector(selectCustomReportData);

  // local states
  const [cards, setCards] = React.useState([]);

  useEffect(() => {

    // check for props
    if(props && props.builder) {
      // use builder summary
      if(builderSummary && Object.keys(builderSummary).length > 0 && customReport && customReport.length > 0) {
        // create cards for the stats
        let localCards = [];

        if(builderSummary?.totalPassengers){
          localCards.push({
            title: "Total Passengers",
            value: builderSummary.totalPassengers,
            subtitle: formatRangeDate(builderSummary.dateRange.startDate) + ' - ' + formatRangeDate(builderSummary.dateRange.endDate),
            color: "#3b82f6"
          });
        }

        if(builderSummary?.iata){
          localCards.push({
            title: "Selected IATA",
            value: builderSummary.iata,
            subtitle: 'Report Created for ' + builderSummary.iata + ' Airport',
            color: "#10b981"
          });
        }

        // push cards
        setCards(localCards);
      }
      else {
        setCards([]);
      }
    }

    else {
      // create cards array using summary object
      // check selected report type
      if(selectedReportType == 'passenger-breakdown') {
          if(summary) {
            // need to create a total, inbound + outbound cards
            const localCards = [];

            // push total pax
            localCards.push({
              title: "Total Passengers",
              value: summary.totalInboundPassengers + summary.totalOutboundPassengers,
              subtitle: formatRangeDate(summary.dateRange.startDate) + ' - ' + formatRangeDate(summary.dateRange.endDate),
              color: "#3b82f6"
            });

            // push outbound pax
            localCards.push({
              title: "Inbound Passengers",
              value: summary.totalInboundPassengers,
              //subtitle: formatRangeDate(summary.dateRange.startDate) + ' - ' + formatRangeDate(summary.dateRange.endDate),
              color: "#10b981"
            });

            // push outbound pax
            localCards.push({
              title: "Outbound Passengers",
              value: summary.totalOutboundPassengers,
              //subtitle: formatRangeDate(summary.dateRange.startDate) + ' - ' + formatRangeDate(summary.dateRange.endDate),
              color: "#f59e0b"
            });

            // once done, set the cards
            setCards(localCards);
          }
      }
      else if(selectedReportType == 'passenger-records') {
        if(passengerRecordsSummary){
        
          const localCards = [];

          // total passengers
          localCards.push({
            title: "Total Passengers",
            value: passengerRecordsSummary.totalPassengers,
            subtitle: formatRangeDate(passengerRecordsSummary.dateRange.startDate) + ' - ' + formatRangeDate(passengerRecordsSummary.dateRange.endDate),
            color: "#3b82f6"
          });

          // total allocated tasks
          localCards.push({
            title: "Total Allocated Tasks",
            value: passengerRecordsSummary.totalJourneys,
            subtitle: 'The number of different tasks assigned to agents',
            color: "#10b981"
          });

          // set cards
          setCards(localCards);

        }
      }
      else {
          setCards([]);
      }
    }
  }, [summary, selectedReportType, props, builderSummary]);

  return (
    <div>
      {/* map each card */}
      <StatCards cards={cards} />
    </div>
  )
};

export default PassengerStatCards;
